import type { RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { ordersLoader } from './orders-loader';

export const ordersRoutes: RouteObject = {
  loader: ordersLoader,
  children: [
    {
      path: '/orders',
      lazy: lazyComponent(
        () => import('@pages/client/order-coupon/coupon-orders-page'),
        'CouponOrdersPage',
      ),
    },
    {
      path: '/coupon-orders/templates',
      lazy: lazyComponent(
        () => import('@pages/client/order-coupon/coupon-order-templates-page'),
        'CouponOrderTemplatesPage',
      ),
    },
    {
      path: '/coupon-orders/templates/:id/edit',
      lazy: lazyComponent(
        () => import('@pages/client/order-coupon/coupon-order-edit-template-page'),
        'CouponOrderEditTemplatePage',
      ),
    },
    {
      path: '/coupon-orders/create',
      lazy: lazyComponent(
        () => import('@pages/client/order-coupon/coupon-order-create-page'),
        'CouponOrderCreatePage',
      ),
    },
    {
      path: '/fuel-orders/create',
      lazy: lazyComponent(
        () => import('@pages/client/order-fuel/fuel-order-create-page'),
        'FuelOrderCreatePage',
      ),
    },
    {
      path: '/fuel-orders/:id/payment',
      lazy: lazyComponent(
        () => import('@pages/client/order-fuel/fuel-order-payment-page'),
        'FuelOrderPaymentPage',
      ),
    },
    {
      path: '/coupon-orders/:id',
      lazy: lazyComponent(
        () => import('@pages/client/order-coupon/coupon-order-details-page'),
        'CouponOrderDetailsPage',
      ),
    },
  ],
};
